var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5V3.75",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5V3.75",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.375V10.2225C15.0825 9.69 14.235 9.375 13.3125 9.375C12.39 9.375 11.5275 9.69748 10.8525 10.245C9.945 10.9575 9.375 12.075 9.375 13.3125C9.375 14.0475 9.58501 14.7525 9.94501 15.3375C10.2225 15.795 10.5825 16.1925 11.01 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25H9.75",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12H7.215",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.3125C17.25 14.0475 17.04 14.7525 16.68 15.3375C16.47 15.6975 16.2075 16.0125 15.9 16.2675C15.21 16.8825 14.31 17.25 13.3125 17.25C12.45 17.25 11.655 16.9725 11.01 16.5C10.5825 16.1925 10.2225 15.795 9.94501 15.3375C9.58501 14.7525 9.375 14.0475 9.375 13.3125C9.375 12.075 9.945 10.9575 10.8525 10.245C11.5275 9.69748 12.39 9.375 13.3125 9.375C14.235 9.375 15.0825 9.69 15.75 10.2225C16.665 10.9425 17.25 12.06 17.25 13.3125Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 15.1875C13.3125 14.1525 14.1525 13.3125 15.1875 13.3125C14.1525 13.3125 13.3125 12.4725 13.3125 11.4375C13.3125 12.4725 12.4725 13.3125 11.4375 13.3125C12.4725 13.3125 13.3125 14.1525 13.3125 15.1875Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon2);
export default __webpack_public_path__ + "static/media/calenderIcon2.c3cc0ea98c22166955b9e5eb4aad011f.svg";
export { ForwardRef as ReactComponent };